module.exports = __webpack_public_path__ + "static/media/SR BIPC(20-06-2026).8694c24d.xlsx";